import { LegalDocumentMetadata } from '../models/legal-documents-metadata';

export function getMetadataBySubSection(legalDocumentMetadata: LegalDocumentMetadata[], subSection: string) {
  return legalDocumentMetadata.filter((metadata) => metadata.subSection === subSection);
}
